import axios from 'axios';
import { GetAllAvailabilityPayload } from './availabilityReportInterfaces';
import OperationTypes from "../../../types";

export { availabilityReportActions };

export interface IPayloadAvailabilityByGroup {
    pickUpList: {
        displayName?: string,
        locationId?: string,
        locationType?: string,
    }[],
    onlyCustomerAtDesk: boolean,
}

function availabilityReportActions() {
    const baseUrl = ``;

    return {
        getAllData,
        getAllCarSegmentsAndClasses,
        downloadExcel,
        getAllLocationAngGroup,
        getAvailabilityByGroup,
    }

    async function getAllData(tenant:string,payload: GetAllAvailabilityPayload) {
        return new Promise(function (resolve, reject) {
            axios.post(`${baseUrl}/availability/getAvailabilityCarClassOrSegment`, payload,{params:{tenant:tenant}}
            ).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error.response)
            })
        });
    }

    async function getAvailabilityByGroup(tenant: string, payload: IPayloadAvailabilityByGroup) {
        return axios.post(`${baseUrl}/availability/getAvailabilityByGroup`, payload, {
            params: {
                tenant: tenant,
            }
        }).then(response => response.data);
    }

    async function getAllCarSegmentsAndClasses(tenant:string) {
        return axios.get<OperationTypes.CarSegmentCategory[]>(`/availability/getAllCarSegmentsAndClasses`, { params:{tenant:tenant}})
        .then(
            response => response.data
        );
    }

    async function downloadExcel(tenant:string,payload: GetAllAvailabilityPayload) {
        return new Promise(function (resolve, reject) {
            axios.post(`${baseUrl}/availability/downloadExcelReport`, payload, {
                params:{tenant:tenant},
                responseType: 'arraybuffer',
                headers: { 'Access-Control-Allow-Origin': true }
            }
            ).then(function (response) {
                resolve(response);
            }).catch(function (error) {
                reject(error)
            })
        });
    }

    async function getAllLocationAngGroup(tenant: string) {
        return new Promise(function (resolve, reject) {
            const params = {
                tenant: tenant,
                pageSize: 10000,
                pageNumber: 0
            }
            axios.get(`${baseUrl}/availability/getAllLocationsAndGroups`,{params:params}
            ).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error.response)
            })
        });
    }

}